import { useRouter } from 'next/compat/router';

export function useGetSessionId(): string {
  const router = useRouter();

  const sessionId = router?.query['session-id'];
  return Array.isArray(sessionId) ? sessionId[0] ?? '' : sessionId ?? '';
}
